import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Booking, IProperty, IWizardStep, Property } from '@clooper/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BookingWizardService {
  formInstance = new BehaviorSubject<{ formName: string, formGrp: FormGroup }>(({} as any));
  bookingInstance = new BehaviorSubject<Booking>((null as any));
  steps: IWizardStep[] = [
    {
      name: 'Details',
      description: '',
      url: '/bookings/create',
      draft_stage: 1
    },
    {
      name: 'Contact',
      description: '',
      url: '/bookings/create/contact',
      draft_stage: 2
    },
    {
      name: 'Pricing',
      description: '',
      url: '/bookings/create/pricing',
      draft_stage: 3
    },
    {
      name: 'Confirmation',
      description: '',
      url: '/bookings/create/confirm',
      draft_stage: 4
    },

  ];

  currentStep!: IWizardStep;

  constructor(private router: Router) { }

  resumeProperty(property: Property | IProperty) {
    const step = this.steps.find(step => step.draft_stage == property.draft_stage);
    const queryParams = { type: property.occupancy_type }
    this.router.navigate([step?.url, property.id], { queryParams }).then(() => {
      window.location.reload();
    });
  }
}
